import types from "../types/types";

const hotCredentials = (attributes) => (dispatch) => {
  dispatch({
    type: types.SET_HOT_CREDENTIALS,
    payload: attributes,
  });
};
export default hotCredentials;
